import React, {ReactNode} from 'react';
import HelpIcon from 'material-ui/svg-icons/action/help';
import classNames from 'classnames';
import Popover from 'material-ui/Popover';
import './ClickableHelpIcon.styl';
import {getMuiV4Theme} from 'utils/css/themeUtils';

interface ClickableHelpIconProps {
  // TODO Can't think of any reason this should be a function. Refactor at some point.
  text: ReactNode | (() => ReactNode);
  // Close tooltip if user's mouse leaves the tooltip
  closeOnHover?: boolean;
  canAutoPosition?: boolean;
  className?: string;
}

interface ClickableHelpIconState {
  open: boolean;
}

export default class ClickableHelpIcon extends React.PureComponent<
  ClickableHelpIconProps,
  ClickableHelpIconState
> {
  iconRef;
  timeoutHandler;

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.tooltipEnter = this.tooltipEnter.bind(this);
    this.bodyClick = this.bodyClick.bind(this);
    this.state = {open: false};
  }

  onClick(e) {
    e.stopPropagation();
    if (!this.state.open) {
      document.addEventListener('click', this.bodyClick);
    } else {
      document.removeEventListener('click', this.bodyClick);
    }
    this.setState({open: !this.state.open});
  }

  onMouseLeave() {
    if (this.props.closeOnHover) {
      document.removeEventListener('click', this.bodyClick);
      this.timeoutHandler = setTimeout(() => this.setState({open: false}), 200);
    }
  }

  tooltipEnter() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
    }
  }

  bodyClick() {
    if (this.state.open) {
      this.setState({open: false});
      document.removeEventListener('click', this.bodyClick);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.bodyClick);
  }

  render() {
    const {text, canAutoPosition} = this.props;

    return (
      <span className="clickable-help-icon" ref={ref => (this.iconRef = ref)}>
        <div onMouseLeave={this.onMouseLeave}>
          <HelpIcon color={getMuiV4Theme().palette.primary.main} onClick={this.onClick} />
        </div>
        {this.state.open && (
          <Popover
            className={classNames('destyle-popover clickable-help-popover', this.props.className)}
            canAutoPosition={canAutoPosition || false}
            open={true}
            useLayerForClickAway={false}
            anchorEl={this.iconRef}
            anchorOrigin={{
              horizontal: 'middle',
              vertical: 'top',
            }}
            targetOrigin={{
              horizontal: 'middle',
              vertical: 'bottom',
            }}>
            <div
              className="tooltip-container"
              onMouseLeave={this.onMouseLeave}
              onMouseEnter={this.tooltipEnter}>
              <div className="ev-tooltip">
                <div className="tooltip-content">{typeof text === 'function' ? text() : text}</div>
              </div>
            </div>
          </Popover>
        )}
      </span>
    );
  }
}
